/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import { SectionHeader, FotterWidthButtons } from './main'
import SectionDivider from './sectionDivider'
import propTypes from 'prop-types'
import styled from 'styled-components'
import { ButtonBase } from '@material-ui/core'

const Button = styled(ButtonBase)`
  background-color: var(--second);
  font-size: 1.3em;
  color: #fff;
  padding: .2em 3em;
  border-radius: 50px;
  margin: 1em 0em;
  @media screen and (max-width: 500px) {
    padding: .4em 1em;
    margin: 1em auto;
  }
`

const Body = styled.div`
  margin: 5em 0em;
  @media screen and (max-width: 500px) {
    text-align: center;
  }
`

const FormShadow = styled.form`
  display: none;
`

const FooterText = styled.div`
  font-size: 1.1em;
  color: var(--first);
`

const OutForm = props => {
  const handleSubmit = () => {
    document.getElementById('form').submit()
  }

  return (
    <SectionDivider step={3}>
      <SectionHeader
        title='Contesta el estudio Epidemiológico'
        subtitle='Estudio epidemiológico de caso sospechoso de enfermedad respiratoria viral.'
      />
      <Body>
        <Button onClick={handleSubmit}>
          Contestar estudio Epidemiológico
        </Button>
        <FotterWidthButtons onBack={props.onBack} hideConfirm justify='center' />
      </Body>
      <FormShadow id='form' action='https://www.laboratoriosiml.com/registro/' method='post' enctype='text/plain'>
        <input type='hidden' name='url_redirect' value={`${window.location.protocol}//${window.location.host}/appointment/${props.id}`} />
      </FormShadow>
      <FooterText>* No es obligatorio contestar <b>Fecha de notificación en plataforma</b> y <b>Folio de plataforma</b>.</FooterText>
      <br />
      {/* <FooterText>La toma de la muestra solo aplica en la Sucursal UNIDAD ARCOS Dirección: Ramón Rodríguez Familiar #36, Jardines de Querétaro, Querétaro, Qro. 76020. (<a style={{ color: 'var(--second)' }} href='https://www.google.com.mx/maps/place/iml+Laboratorio+M%C3%A9dico/@20.5951062,-100.3792402,17z/data=!3m1!4b1!4m5!3m4!1s0x85d35b341055d781:0x146f46a53b9508d1!8m2!3d20.5951012!4d-100.3770515' target='_blank'>Ver mapa</a>).</FooterText> */}
    </SectionDivider>

  )
}

OutForm.propTypes = {
  id: propTypes.string,
  onBack: propTypes.func
}

export default OutForm
